import React from "react";
import "./components.css";
import OoPopover from "../../../components/UI/Popover/OoPopover"

const MaturityModelProgressBar = ({ value, labelImgData, threshhold }) => {
  // Ensure value is between 0 and 100
  // const normalizedValue = Math.min(Math.max(value, 0), 100);



  const handleDownload = (img, name) => {
    const link = document.createElement("a");
    link.href = img;
    link.download = `Badge ${name}.png`; // Set the file name for the download

    // Append the link to the body temporarily, trigger click, and remove the link
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isValidDownload=(range)=>{
    if(value > range[0] && value > range[1]){
      return true
    }else{
      return false
    }
  }

  return (
    <div className={`maturity-model-wrapper ${value == 0?"disabled":""}`}>
      <div className="maturity-model-container">
        <div className="maturity-model-fill" style={{ width: `${value}%` }} />
        <div className="maturity-model-separator"></div>
        <div className="maturity-model-separator"></div>
        <div className="maturity-model-separator"></div>
        {threshhold ? (
          <div
            className="maturity-model-threshold"
            style={{ left: `${threshhold}%` }}
          ></div>
        ) : (
          ""
        )}
      </div>
      <div className="maturity-model-labels">
        {labelImgData && labelImgData.map((t) => {
          return (
            <div key={t}>
              <div>{t.text} <OoPopover target={`mm_progressbar_popover_${t.text.replace(" ","")}`} headerText={t.text} bodyText={t.tooltipText}  /> </div>
              <div
                className={isValidDownload(t.range)?"download-badge-link":"download-badge-link disabled"}
                onClick={() => {
                  handleDownload(t.image, t.text);
                }}
              >
                (Download badge)
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MaturityModelProgressBar;
